import api from "@/util/google.util";
import { ref } from "vue"

export const useGoogleSetup = () => {
    const loading = ref(false);
    const message = ref('');

    const doLinkGoogle = async () => {
        loading.value = true;
        message.value = '';

        const tmpWindow = window.open(undefined, "auth popup", "width=400,height=500,left=100,top=100");
        try {
            await api.linkGoogle(tmpWindow);
            message.value = "Successfully linked to Google"
        } catch (e) {
            if(e instanceof Error) {
                message.value = e.message;
            }
        } finally {
            loading.value = false;
        }
    }

    const doUnlinkGoogle = async () => {
        loading.value = true;
        message.value = '';
        try {
            await api.unlinkGoogle();
            message.value = 'Successfully unlinked Google';
        } catch (e) {
            if(e instanceof Error) {
                message.value = e.message;
            }
        } finally {
            loading.value = false;
        }
    }

    // TODO: Error state?
    // TODO: Ref showing if currently linked

    return { loading, message, doLinkGoogle, doUnlinkGoogle }
}